<template>
  <div class="content line_height">
    <div v-html="data"></div>
    <template v-if="platform == 'user'">
      <div class="attachment">
        <span>附件：</span>
        <span class="SDK" @click="toIllegalOrderRules">《违规订单处理规则》</span>
      </div>
    </template>
  </div>
</template>

<script>
import http from '@/utils/axios'
export default {
  data() {
    return {
      data: '',
      platform: '',
    }
  },
  created() {
    this.getfindUserServiceTerms()
  },
  methods: {
    getfindUserServiceTerms() {
      const {platform} = this.$route.query;
      this.platform = platform || 'user';
      let url = platform == 'bees'?'sys/admin/sys_var/findBeesServiceTerms':'sys/admin/sys_var/findUserServiceTerms';
      http({
        url: url,
        method: 'get',
        parmes: {}
      }).then(res => {
        if (res.code == 200) {
          this.data = res.data
          this.$loading.hide();
        }
      })
    },
    toIllegalOrderRules() {
      this.$router.push({
        path: '/illegalOrderRules'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 30px 30px 30px;
  .attachment {
    margin-top: 40px;
    font-size: 26px;
    .SDK {
      text-decoration: underline;
    }
  }
}
</style>